import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M30.7999 0C31.0815 0 31.3629 0.107387 31.5777 0.322231C32.0073 0.751781 32.0073 1.44829 31.5777 1.87784L12.5555 20.9L31.5777 39.9222C32.0073 40.3518 32.0073 41.0483 31.5777 41.4778C31.1481 41.9074 30.4516 41.9075 30.0221 41.4778L10.2221 21.6778C9.79247 21.2483 9.79247 20.5518 10.2221 20.1222L30.0221 0.322231C30.2369 0.107387 30.5184 0 30.7999 0V0Z" fill="black"/>
</svg>
;
